import { SEASON_PASS_NEW_SEASON_FTUX, SEASON_PASS_UNLOCK_LEVEL } from "Constants/SeasonPass";
import { FTUXType } from "Player/PlayerProperty/Progress/FTUXType";
import { FTUXStateHelper } from "State/Game/FTUX/FTUXStateHelper";
import { IPlayerState } from "../IPlayerState";
import { getHighestLevelCompleted } from "../PlayerLevelHelper";
import { PlayerStateHelper } from "../PlayerStateHelper";
import { PlayerTask } from "../PlayerTasks";
import { hasFlag } from "../PlayerFlagHelper";
import { IGameState } from "State/Game/IGameState";
import { NonVariableRewardData, NonVariableRewards } from "Types/Reward";
import { mergeRewards } from "Utility/RewardHelper";

export namespace SeasonPassStateHelper {
    export function queueSeasonPassFTUXIfNeeded(playerState: IPlayerState): IPlayerState {
        if (
            getHighestLevelCompleted(playerState) >= SEASON_PASS_UNLOCK_LEVEL &&
            !FTUXStateHelper.isFtuxCompleted(playerState, FTUXType.SEASON_PASS) &&
            FTUXStateHelper.isFtuxCompleted(playerState, FTUXType.QUESTS) &&
            playerState.tasks.find(task => task.task === PlayerTask.EVENT_FTUX) === undefined &&
            playerState.tasks.find(task => task.task === PlayerTask.SEASON_PASS_FTUX) === undefined
        ) {
            return PlayerStateHelper.addStateTaskDatas(playerState, [
                {
                    task: PlayerTask.SEASON_PASS_FTUX,
                    isNewSeason: false
                },
            ]);
        }
        if (
            FTUXStateHelper.isFtuxCompleted(playerState, FTUXType.SEASON_PASS) &&
            !hasFlag(playerState, SEASON_PASS_NEW_SEASON_FTUX) &&
            playerState.tasks.find(task => task.task === PlayerTask.EVENT_FTUX) === undefined &&
            playerState.tasks.find(task => task.task === PlayerTask.SEASON_PASS_FTUX) === undefined
        ) {
            return PlayerStateHelper.addStateTaskDatas(playerState, [
                {
                    task: PlayerTask.SEASON_PASS_FTUX,
                    isNewSeason: true
                },
            ]);
        }
        return playerState;
    }

    export function getSeasonPassFTUXTextAfterEvent(playerState: IPlayerState): string {
        if (
            getHighestLevelCompleted(playerState) >= SEASON_PASS_UNLOCK_LEVEL &&
            !FTUXStateHelper.isFtuxCompleted(playerState, FTUXType.SEASON_PASS)
        ) {
            return 'SeasonPassTutorialRewardsTab';
        }
        if (
            FTUXStateHelper.isFtuxCompleted(playerState, FTUXType.SEASON_PASS) &&
            !hasFlag(playerState, SEASON_PASS_NEW_SEASON_FTUX)
        ) {
            return 'SeasonPassTutorialNewSeasonTab';
        }
        return undefined;
    }

    export function getUnClaimedPremiumSeasonPassRewards(state: IGameState): NonVariableRewardData[] {
        let rewards: NonVariableRewards = [];
        for (let i = 0; i < state.playerState.seasonPass.currentRank; i++) {
            rewards = [...rewards, ...state.playerState.seasonPass.ranks[i].premium.rewards];
        }
        rewards = mergeRewards(rewards);

        return rewards;
    }
}